// extracted by mini-css-extract-plugin
export default {"modalCarouselCrossButton":"style_modalCarouselCrossButton__q38sV","sliderDotsList":"style_sliderDotsList__E0BOn"};